import React, { createContext, useContext, useEffect, useState } from "react";

const SessionCtx = createContext(null);
const STORAGE_KEY = "gf.session";

export function SessionProvider({ children }) {
  const [session, setSession] = useState(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  });

  useEffect(() => {
    if (session) localStorage.setItem(STORAGE_KEY, JSON.stringify(session));
    else localStorage.removeItem(STORAGE_KEY);
  }, [session]);

  const clear = () => setSession(null);

  return (
    <SessionCtx.Provider value={{ session, setSession, clear }}>
      {children}
    </SessionCtx.Provider>
  );
}

export const useSession = () => {
  const ctx = useContext(SessionCtx);
  if (!ctx) throw new Error("useSession must be used within SessionProvider");
  return ctx;
};
